/*
 *
 * ResetPassword reducer
 *
 */
import { createSlice } from '@reduxjs/toolkit';

import { resetPasswordAct, resetResetPasswordAct } from './actions';

export const initialState = {
  loadingState: 0,
};

/* eslint-disable default-case, no-param-reassign */
const resetPasswordSlice = createSlice({
  name: 'ResetPassword',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(resetPasswordAct, (state, { payload }) => {
        const { loadingState } = payload;
        state.loadingState = loadingState;
      })
      .addCase(resetResetPasswordAct, () => initialState);
  },
});

export default resetPasswordSlice.reducer;
